import React from 'react';
import { FiSearch } from 'react-icons/fi';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import Button from '~components/button';

const NoResults = ({ accountType, locationId }) => {
  const intl = useIntl();

  return (
    <div className="c-matches__no-results">
      <FiSearch />
      <strong>
        {intl.formatMessage({
          id: 'containers.favorites.list.no-favorites',
          defaultMessage: "You haven't bookmarked any offers as favourites.",
        })}
      </strong>
      <Link
        to={`${accountType === 'worker' ? '/customers' : '/workers'}${locationId ? `?locationId=${locationId}` : ''}`}
      >
        <Button type="button" className="c-btn c-matches__subscription-text l-grey">
          {accountType === 'worker'
            ? intl.formatMessage({ id: 'containers.favorites.list.view-clients', defaultMessage: 'View customers' })
            : intl.formatMessage({ id: 'containers.favorites.list.view-workers', defaultMessage: 'View workers' })}
        </Button>
      </Link>
    </div>
  );
};

export default NoResults;
